import { makeAutoObservable, runInAction } from 'mobx'
import invoiceApi from '../../api/invoice.api'
import { restaurantConfig, storeMobx, restaurantCenter, RESTAURANT_EVENT } from 'restaurant'
import { memberMobx } from '@mobxStore'
import { ddayjs } from '@dt/fe-utils'
import { filter, map, sumBy, keyBy, isArray, find, cloneDeep } from '@dt/fe-utils/dist/lodash'

class Invoice {
  constructor () {
    makeAutoObservable(this)
    restaurantCenter.on(RESTAURANT_EVENT.STORE_CHANGED, (storeInfo: IViewStore) => {
      if (restaurantConfig.app === 'pos') {
        const { invoiceAutoPrint = 1 } = storeInfo.storeExtInfo
        this.autoInvoicePrint = invoiceAutoPrint
      }
      if (bo === 'cn') {
        this.init()
      }
    })
  }
  /** 操作是否进行中 */
  isLoading: boolean = false
  /** 可以开发票的订单列表(pos mobile 通用) */
  invoiceOrderList: IOrder[] = []
  /** 电子发票pos正在搜索的内容 */
  invoiceSearch = ''
  /** 当前勾选的订单 */
  selectedOrders: IOrder[] = []
  /** 电子发票自动打印是否开启(默认开启) */
  autoInvoicePrint: boolean = true
  /** 当前门店有没有配置电子发票方案 */
  storeInvoiceStatus: boolean = true
  /** 当前品牌方案中已经停用了的门店list(手机端过滤使用) */
  disableInvoiceStoreList: number[] = []
  /** 当前品牌所有方案中应用了电子发票发方案的门店列表 */
  useingInvoiceStoreList: number[] = []
  /** 当前查询到的订单  */
  curInvoiceOrderList: IOrder[] = []
  /** 当前勾选的订单ids  */
  get selectedIds () {
    return map(this.selectedOrders, (item: IOrder) => item.ordersId)
  }
  /** 当前哪些门店的订单被选中(mobile中需要的单门店判断)  */
  get selectStoreIds () {
    return map(this.selectedOrders, (item: IOrder) => item.storeId)
  }
  get invoiceOrderListMaps () {
    return keyBy(this.invoiceOrderList, 'ordersId')
  }
  /** 当前电子发票列表中，可以开票的真值 */
  get validOrders () {
    const list = filter(this.curInvoiceOrderList.length ? this.curInvoiceOrderList : this.invoiceOrderList, (item: IOrder) => (!item.openInvoiceStatus || item.openInvoiceStatus === 'fail' || item.openInvoiceStatus === 'signFail') && item.invoiceAmount > 0)
    return filter(list, (item: IOrder) => item.storeId === list[0].storeId)
  }
  /** 当前是否全选中了 */
  get isSelectAll () {
    return (this.validOrders.length === this.selectedIds.length && this.selectedIds.length) ? 'action' : this.selectedIds.length ? 'noall' : ''
  }
  /**
   * 当前品牌是否可以允许开票自动开票
   * mobile需要判断 1.商家后台品牌中开了开关. 2.当前门店开通了电子发票功能 3.bo 为cn
   * pos 判断 1.当前门店开通了电子发票功能 2.bo 为cn
  */
  get hasOpenInvoice () {
    if (restaurantConfig.app === 'mobile') {
      return storeMobx.brand.extInfo && storeMobx.brand.extInfo.mobileTicketBySelf === '1' && this.storeInvoiceStatus && window.bo === 'cn'
    } else {
      return this.storeInvoiceStatus && window.bo === 'cn'
    }
  }
  /** 当前选中的票的总和 */
  get totalInvoicePrice () {
    return sumBy(this.selectedOrders, (item: IOrder) => item.invoiceAmount || item.paidFee)
  }
  /** 判断当前提交之前的选中的发票列表是否完全符合 */
  get checkSelectInvoiceIsVaild () {
    const checkStoreIdS: number[] = map(this.selectedOrders, (item: IOrder) => item.storeId)
    /**
     * 没有验证通过的数据
     * 如果是手机端，如果是多门店情况下，选中一家门店之后，别的门店的都要disable
    **/
    const notVaildData = this.selectedOrders.filter((item: IOrder) => {
      return item.ordersType !== 'dc' || item.status !== 'Success'
    })
    return !notVaildData.length
  }
  /** 获取当前开票的Url地址 只有pos单独点击时才会传参数，否则直接取当前订单中的 */
  getInvoiceUrl (url: string, orderId?: string) {
    let ordersId: string | string[] = orderId || this.selectedIds
    if (isArray(ordersId)) {
      ordersId = ordersId.join(',')
    }
    let invoiceUrl = `${url}?b=${storeMobx.info.brandId || restaurantConfig.brandId}&s=${storeMobx.info.storeId}&o=${ordersId}&from=${restaurantConfig.app}&token=${Config.token}`
    if (restaurantConfig.app === 'mobile' && this.invoiceOrderList.length) {
      /** 手机端取门店号要用列表中选中的门店，只能开当前门店的其中一个 */
      invoiceUrl = `${url}?b=${storeMobx.info.brandId || restaurantConfig.brandId || this.invoiceOrderList[0].brandId}&s=${this.invoiceOrderList[0].storeId}&o=${ordersId}&from=${restaurantConfig.app}&token=${Config.token}`
    }
    if (orderId) {
      const resOrder: IOrder | undefined = find(this.invoiceOrderList, (item: IOrder) => item.ordersId === orderId)
      return {
        url: invoiceUrl,
        totalPrice: resOrder ? resOrder.invoiceAmount || resOrder.paidFee || 0 : 0
      }
    } else {
      return {
        url: invoiceUrl,
        totalPrice: this.totalInvoicePrice
      }
    }
  }
  setSearchInvoice (value: any) {
    this.invoiceSearch = value
  }
  /** 切换是否全选 */
  toggleChcek = (order: IOrder, isCheckAll = false) => {
    if (!isCheckAll) {
      this.selectedOrders = this.selectedIds.includes(order.ordersId) ? filter(this.selectedOrders, (item: IOrder) => item.ordersId !== order.ordersId) : [...this.selectedOrders, order]
    } else {
      this.selectedOrders = this.isSelectAll === 'action' ? [] : this.validOrders
    }
  }
  // 删除当前列表中的其中一项
  cleaerInvoiceInfo = (orderid: string) => {
    this.invoiceOrderList = filter(this.invoiceOrderList, (item: IOrder) => item.ordersId !== orderid)
    if (this.selectedIds.includes(orderid)) {
      this.selectedOrders = filter(this.selectedOrders, (item: IOrder) => item.ordersId !== orderid)
    }
  }
  /** 点击查谒 */
  async search (times?: { startTime: string; endTime: string }) {
    this.isLoading = true
    if (this.invoiceSearch.length || restaurantConfig.app === 'mobile') {
      invoiceApi.search({
        nono: this.invoiceSearch,
        storeId: storeMobx.info.storeId,
        startAddTime: times ? times.startTime : ddayjs().subtract(31, 'days').startOf('day').format(),
        endAddTime: times ? times.endTime : ddayjs().endOf('day').format(),
        pageSize: 300
      }).then((res: any) => {
        let content = (res.result ? res.result.content || [] : [])
        if (content.length) {
          runInAction(() => {
            if (restaurantConfig.app === 'mobile') {
              /** 在手机端, 需要过滤掉已经停用了方案的门店列表 及 有应用了方案的门店列表 */
              content = filter(content, con => !this.disableInvoiceStoreList.includes(con.storeId) && this.useingInvoiceStoreList.includes(con.storeId))
            }
            /** 如果已经搜过了，则不需要加进去 */
            const rContent = filter(content, (item: IOrder) => !this.invoiceOrderListMaps[item.ordersId])
            this.invoiceOrderList = [...this.invoiceOrderList, ...rContent]
            this.invoiceSearch = ''
            this.isLoading = false
            this.curInvoiceOrderList = content
            if (times) this.selectedOrders = []
          })
        } else {
          runInAction(() => {
            this.isLoading = false
            this.invoiceSearch = ''
            this.curInvoiceOrderList = []
          })
        }
      }, () => {
        runInAction(() => {
          this.isLoading = false
          this.invoiceSearch = ''
        })
      })
    } else {
      runInAction(() => {
        this.isLoading = false
      })
    }
  }
  /** 清空订单搜索列表 */
  resetInvoiceList () {
    this.invoiceOrderList = []
    this.invoiceSearch = ''
    this.selectedOrders = []
  }
  async init () {
    // 只有中国需要发票信息
    if (bo !== 'cn') {
      return
    }
    if (!Config.token) {
      return
    }
    if (restaurantConfig.app === 'mobile') {
      if (!memberMobx.memberInfo.memberId) {
        return
      }
      return invoiceApi.brandInvoiceList({
        brandId: storeMobx.info.brandId || Config.BRANDID
      }).then((res: any) => {
        const { result = [] } = res
        const stores: number[] = []
        const disableStoreIds: number[] = []
        result.forEach((item: any) => {
          if (item.status && item.status === 'disable') {
            disableStoreIds.push(...item.storeIds)
          }
          stores.push(...item.storeIds)
        })
        runInAction(() => {
          this.disableInvoiceStoreList = disableStoreIds
          this.storeInvoiceStatus = !!stores.length
          this.useingInvoiceStoreList = stores
        })
      })
    } else {
      return invoiceApi.getStoreInvoiceInfo({
        storeId: storeMobx.info.storeId,
      }).then((res: any) => {
        runInAction(() => {
          this.storeInvoiceStatus = res ? res.result : false
        })
      })
    }
  }
}

export default new Invoice()
